<template>
  <i-container class="_align-self:stretch _padding:0" am-table-view fluid>
    <div
      class="tabs -sm -stretch"
      :am-db-tabs="$store.state.partCategories.selectedCategory"
      v-if="subCategories($route.params).table"
    >
      <div class="tabs-header">
        <div
          v-for="sub in subCategories($route.params).table.subCategories"
          :key="sub.code"
          :class="`tab-title ${$route.params.subtable.includes(sub.id + '-' + sub.code) ? '-active' : null}`"
          @click="changeActiveTab(sub)"
        >
          {{ sub.name }}
        </div>
      </div>
    </div>
    <the-table
      v-if="parts.data[$route.params.subtable]"
      :tableData="parts.data[$route.params.subtable]"
    />
    <div
      v-else
      class="_align-self:stretch _display:flex _justify-content:center _align-items:center _height:100%"
    >
      <i-loader color="primary" />
    </div>
    <warning-modal
      v-if="isShowWarning"
      @delete="del"
      @save="save"
      :isDisabled="parts.saveLoading"
      v-model="isShowWarning"
    />
  </i-container>
</template>

<script>
import TheTable from '@/components/TheTable'
import warningModal from '@/components/tableItems/warningModal'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'DataBaseView',
  components: {
    TheTable,
    warningModal
  },
  data: () => ({
    isShowWarning: false,
    link: null,
    saveListener: null
  }),
  computed: {
    ...mapState([
      'partCategories',
      'parts'
    ]),
    ...mapGetters('partCategories', ['subCategories'])
  },
  beforeRouteUpdate (to, from) {
    if (
      (this.parts.changedParts[this.$route.params.subtable] || this.parts.changedImages[this.$route.params.subtable]) &&
      Object.keys(to.query).length !== 0 && Object.keys(from.query).length !== 0
    ) {
      this.isShowWarning = true
      this.link = to
      return false
    }
  },
  beforeRouteLeave (to) {
    if (this.parts.changedParts[this.$route.params.subtable] || this.parts.changedImages[this.$route.params.subtable]) {
      this.isShowWarning = true
      this.link = to
      return false
    }
  },
  methods: {
    ...mapActions('partCategories', ['getPartCategories', 'setCategories', 'getIdByCode']),
    ...mapActions('partsErrors', ['delAllErrors']),
    ...mapActions('parts', ['getParts', 'saveChangedParts']),
    ...mapMutations('partCategories', ['setSubSubCategory']),
    ...mapMutations('ui', ['setErrorPart']),
    ...mapMutations('parts', ['DEL_CHANGED_PARTS', 'DEL_CHANGED_IMAGES', 'setData', 'setModalRow']),
    ...mapMutations('filter', ['resetFilter']),
    del () {
      this.DEL_CHANGED_PARTS()
      this.DEL_CHANGED_IMAGES()
      this.delAllErrors()
      this.setErrorPart({ rowIndex: null, colIndex: null, index: null })
      this.goLink()
    },
    async save () {
      const sending = await this.saveChangedParts(this.$route.params.subtable)
      if (sending) this.goLink()
    },
    goLink () {
      this.isShowWarning = false
      this.$router.push(this.link.fullPath)
      this.link = null
    },
    async changeActiveTab (tab) {
      this.setSubSubCategory({ code: tab.id + '-' + tab.code })
      const maincatId = await this.getIdByCode({ code: this.$route.params.db })
      const subcatId = await this.getIdByCode({ code: this.$route.params.table, level: 1 })
      this.$router.push({
        name: 'DataBaseView',
        params: { subtable: tab.id + '-' + tab.code + '-' + subcatId + '-' + maincatId }
      })
    },
    openModalById (id = null) {
      if (!id) {
        id = this.$route.query.part_id
      }
      if (!id) {
        return
      }
      for (const categoryId in this.parts.data) {
        const categoryData = this.parts.data[categoryId]
        for (const part of categoryData.parts) {
          if (part.name === 'id' && +part.data === +id) {
            this.setModalRow(part.rowIndex)
            return
          }
        }
      }
    }
  },
  async beforeMount () {
    if (this.partCategories.data.length === 0) await this.getPartCategories()
    this.setCategories(this.$route.params)
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        this.setCategories(this.$route.params)
        if (!this.$route.params.subtable) return
        if (JSON.stringify(toParams) === JSON.stringify(previousParams)) return
        this.resetFilter()
        this.$store.state.filter.isShowFilter = false
        this.getParts(this.$route.params).then(() => this.openModalById())
        const tableWrapper = document.querySelector('[am-table-wrapper]')
        if (tableWrapper) {
          tableWrapper.scrollTo({
            top: 0,
            left: 0
          })
        }
      },
      { immediate: true }
    )
    if (!this.saveListener) {
      this.saveListener = e => {
        if (e.ctrlKey && e.key === 's') {
          e.preventDefault()
          this.save()
        }
      }
      document.addEventListener('keydown', this.saveListener)
    }
    window.dbView = this
  },
  beforeUnmount () {
    if (this.saveListener) {
      document.removeEventListener('keydown', this.saveListener)
      this.saveListener = null
    }
  }
}
</script>

<style lang="scss">
.-dark {
  [am-db-tabs] {
    ----header--background: var(--color--primary-60);
    ----header--background--hover: var(--color--primary-50);
    ----header--background--active: var(--color--primary-50);
    ----header--border-color--active: var(--color--primary-60);
    ----color: var(--color--gray-10);
    ----border-right-color: var(--color--dark-60);
    ----border-bottom-color: var(--color--dark-60);
    ----border-left-color: var(--color--dark-60);
    ----border-top-color: var(--color--dark-60);
    .tabs-header { border: none; }
  }
  [am-db-tabs~='girlswear'] {
    ----header--background: var(--color--info-60);
    ----header--background--hover: var(--color--info-50);
    ----header--background--active: var(--color--info-50);
    ----header--border-color--active: var(--color--info-60);
    ----border-right-color: var(--color--info-60);
    ----border-bottom-color: var(--color--info-60);
    ----border-left-color: var(--color--info-60);
    ----border-top-color: var(--color--info-60);
  }
  [am-db-tabs~='boyswear'] {
    ----header--background: var(--color--success-60);
    ----header--background--hover: var(--color--success-50);
    ----header--background--active: var(--color--success-50);
    ----header--border-color--active: var(--color--success-60);
    ----border-right-color: var(--color--success-60);
    ----border-bottom-color: var(--color--success-60);
    ----border-left-color: var(--color--success-60);
    ----border-top-color: var(--color--success-60);
  }
  [am-db-tabs~='womenswear'] {
    ----header--background: var(--color--secondary-60);
    ----header--background--hover: var(--color--secondary-50);
    ----header--background--active: var(--color--secondary-50);
    ----header--border-color--active: var(--color--secondary-60);
    ----border-right-color: var(--color--secondary-60);
    ----border-bottom-color: var(--color--secondary-60);
    ----border-left-color: var(--color--secondary-60);
    ----border-top-color: var(--color--secondary-60);
  }
}
.-light {
  [am-db-tabs] {
    ----header--background: var(--color--primary-10);
    ----header--border-color--active: var(--color--primary-60);
    color: var(----header--color);
  }
  [am-db-tabs~='girlswear'] {
    ----header--background: var(--color--info-10);
    ----header--border-color--active: var(--color--info-60);
  }
  [am-db-tabs~='boyswear'] {
    ----header--background: var(--color--success-10);
    ----header--border-color--active: var(--color--success-60);
  }
  [am-db-tabs~='womenswear'] {
    ----header--background: var(--color--secondary-10);
    ----header--border-color--active: var(--color--secondary-60);
  }
}

[am-table-view]{
  display: flex;
  flex-direction: column;
  [am-changed-part-buttons] button {
    width: calc(50% - 0.5rem);
  }
}
</style>
